import React from 'react';
import { motion } from 'framer-motion';
export function BrandMoment() {
  return <section className="py-32 md:py-48 px-6 flex flex-col items-center justify-center relative" data-id="element-16">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 1.0,
      ease: 'easeOut'
    }} className="flex flex-col items-center" data-id="element-17">
        <div className="relative w-32 h-32 md:w-48 md:h-48 flex items-center justify-center rounded-full border border-brand-gold/40 mb-16" data-id="element-18">
          <svg viewBox="0 0 100 100" className="w-12 h-12 md:w-16 md:h-16 text-brand-gold" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="square" strokeLinejoin="miter" data-id="element-19">
            <path d="M 35 80 L 35 20 L 60 20 C 71 20 80 29 80 40 C 80 51 71 60 60 60 L 35 60" data-id="element-20" />
          </svg>
        </div>

        <p className="font-heading text-xs tracking-widest text-brand-warmGrey uppercase" data-id="element-21">
          © 2026 Pollock Ventures
        </p>
      </motion.div>
    </section>;
}